module.exports = __webpack_public_path__ + "static/media/bubble-image-13.9d99b88e.png";